var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('a',{staticClass:"header-item",attrs:{"href":_vm.pathto('index')}},[_vm._v("Home")]),_c('div',{staticStyle:{"flex":"1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }